import React, { FC } from 'react';
import './OrderCellRenderer.scss';

type DetailsCellRendererProps = {
    value: any;
};

const DetailsCellRenderer: FC<DetailsCellRendererProps> = ({ value }: DetailsCellRendererProps) => {
    return <div className="order-cell">{value}</div>;
};

export default DetailsCellRenderer;
